import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import getSsn from "../common/Ssn";
import { getDate, getDobDate } from "../common/DisplayDate";
import Address from "./Address";

class HuntingFishingRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const nameNode = _.get(node, "name[0]");
      results.push(
        <Table.Row key={`HuntFish_Record_Name_Row_${this.props.index}`}>
          <Table.Cell>Name:</Table.Cell>
          <Table.Cell>
            {getPersonName(
              _.get(nameNode, "first[0]._", ""),
              "",
              _.get(nameNode, "last[0]._", ""),
              this.props
            )}
          </Table.Cell>
          <Table.Cell>License Type:</Table.Cell>
          <Table.Cell>{_.get(node, "licenseType[0]._", "")}</Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row key={`HuntFish_Record_Address_Row_${this.props.index}`}>
          <Table.Cell>Address:</Table.Cell>
          <Table.Cell>
            <Address addressNode={_.get(node, "address[0]")} {...this.props} />
          </Table.Cell>
          <Table.Cell>License State:</Table.Cell>
          <Table.Cell>{_.get(node, "licenseState[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`HuntFish_Record_Dob_Row_${this.props.index}`}>
          <Table.Cell>Date of Birth</Table.Cell>
          <Table.Cell>
            {getDobDate(_.get(node, "DOB[0]"), {
              userAccount: this.props.userAccount,
            })}
          </Table.Cell>
          <Table.Cell>License Date:</Table.Cell>
          <Table.Cell>{getDate(_.get(node, "licenseDate[0]"))}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`HuntFish_Record_Ssn_Row_${this.props.index}`}>
          <Table.Cell>SSN:</Table.Cell>
          <Table.Cell>{getSsn(_.get(node, "SSN[0]._"), this.props)}</Table.Cell>
          <Table.Cell>Home State:</Table.Cell>
          <Table.Cell>{_.get(node, "homeState[0]._", "")}</Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row key={`HuntFish_Record_Gender_Row_${this.props.index}`}>
          <Table.Cell>Gender:</Table.Cell>
          <Table.Cell>{_.get(node, "sex[0]._", "")}</Table.Cell>
          <Table.Cell />
          <Table.Cell />
        </Table.Row>
      );
      results.push(
        <Table.Row key={`HuntFish_Record_Race_Row_${this.props.index}`}>
          <Table.Cell>Race:</Table.Cell>
          <Table.Cell>{_.get(node, "race[0]._", "")}</Table.Cell>
          <Table.Cell />
          <Table.Cell />
        </Table.Row>
      );
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default HuntingFishingRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/HuntngFishingRecordDetail.js